import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyANK6wMdnQcFPYhd7f1kpf8gHBcGSXC960",
    authDomain: "extern-academy.firebaseapp.com",
    databaseURL: "https://extern-academy-default-rtdb.firebaseio.com",
    projectId: "extern-academy",
    storageBucket: "extern-academy.firebasestorage.app",
    messagingSenderId: "1072674361744",
    appId: "1:1072674361744:web:56f607c211d8c3f0336315",
    measurementId: "G-ZH36ZMGN9X",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
